import { useEffect, useState } from 'react'
import { Box, FlexBox, Icon, IconButton, SearchInput } from '@vp/swan'
import { SearchBar as UbikSearchBar } from '@vp/search-bar'
import { Logger } from '../../../utils/logger'
import { searchContainerOpen } from './search.scss'
import useClient from '../../../hooks/useClient'
import { useI18n } from '../../../context/TranslationContext'

interface SearchBarProps {
  locale: string
  forwardedPath: string
  searchLabel: string
  isExpandedSearchEnabled?: boolean
}

const searchLogger = {
  ...Logger.instance,
  log: (message: string) => {
    Logger.instance.info(message)
  },
  warn: (message: string) => {
    Logger.instance.warning(message)
  },
}

const SearchBar: React.FC<SearchBarProps> = ({ locale, forwardedPath, searchLabel, isExpandedSearchEnabled }) => {
  const { translate } = useI18n()
  const mounted = useClient()
  const [isSearchOpen, setIsSearchOpen] = useState(false)

  const openSearch = () => {
    setIsSearchOpen(true)
  }

  const closeSearch = () => {
    setIsSearchOpen(false)
  }

  useEffect(() => {
    if (isSearchOpen) {
      // Re-compute search-bar dropdown position once css transition is complete
      const evt = new Event('resize')
      window.dispatchEvent(evt)
    }
  }, [isSearchOpen])

  return (
    <FlexBox alignItems="stretch" backgroundColor="standard" className={isSearchOpen ? searchContainerOpen : ''}>
      <IconButton tooltip={translate('search.close')} skin="tertiary" display={{ xs: isSearchOpen ? 'block' : 'none', sm: 'none' }} onClick={closeSearch}>
        <Icon iconType="arrowLeft" size="standard" aria-hidden="true" />
      </IconButton>
      <IconButton
        tooltip={translate('search.open')}
        skin="tertiary"
        onClick={openSearch}
        display={{ xs: !isExpandedSearchEnabled && !isSearchOpen ? 'block' : 'none', sm: 'none' }}
      >
        <Icon iconType="search" size="standard" aria-hidden="true" />
      </IconButton>
      <Box style={{ flex: 1 }} onClick={openSearch} display={{ xs: isExpandedSearchEnabled || isSearchOpen ? 'block' : 'none', sm: 'block' }}>
        {!mounted && <SearchInput placeholder={searchLabel} aria-label={searchLabel} />}
        {mounted && <UbikSearchBar locale={locale} pathname={forwardedPath} searchLabel={searchLabel} logger={searchLogger} />}
      </Box>
    </FlexBox>
  )
}

export default SearchBar
